import { useMemo } from 'react';
import { isMotionV2Script } from '../../../../features/scenarios/scriptContract';
import type { Scenario } from '../types';
import { usesVoiceLines, voiceStatusesFromMotionSync, type SceneVoiceStatus } from '../voiceLines';
import { useSceneHandlers } from './SceneHandlersContext';
import { useScenarioVoiceMap } from './useScenarioVoiceMap';

/**
 * シナリオの各シーンのナレーションの鮮度 (シーン id → 鮮度)。
 * - 声の台本 (motion-v2): モーションの同期の鮮度 (GET /motion/sync-status の voice)。映像の再生成が必要 (videoStale) も含む
 * - それ以外 (歌モノを除く): 話者と声の対応表 (GET /voice-map) の scene_status
 */
export function useScenarioVoiceStatuses(scenario: Scenario): Record<string, SceneVoiceStatus> {
  const { motionSyncStatus } = useSceneHandlers();
  const motion = isMotionV2Script(scenario);
  const { data } = useScenarioVoiceMap(scenario.id, usesVoiceLines(scenario));
  const motionStatuses = motionSyncStatus?.[scenario.id];
  const sceneStatus = data?.scene_status;
  return useMemo(
    () => (motion ? voiceStatusesFromMotionSync(motionStatuses) : (sceneStatus ?? {})),
    [motion, motionStatuses, sceneStatus],
  );
}

/** シーン 1 つのナレーションの鮮度 (無ければ undefined)。 */
export function useSceneVoiceStatus(scenario: Scenario, sceneId: string | null | undefined): SceneVoiceStatus | undefined {
  const statuses = useScenarioVoiceStatuses(scenario);
  return sceneId ? statuses[sceneId] : undefined;
}
